import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { DmpAuthorizationStatus } from 'parog-web/cnam/types';
import type DmpRetrievalContext from 'parog-web/contexts/dmp-retrieval-context';
import Button from 'ui-kit/components/button';
import Checkbox from 'ui-kit/components/checkbox';

interface Args {
  context: DmpRetrievalContext;
  onDismiss: () => void;
}

export default class DmpAccessFormAuthorizationStateComponent extends Component<Args> {
  @tracked shouldAuthorizeMedicToAccessPatientDmp = false;

  get isAuthorizationExpired(): boolean {
    return (
      this.args.context.medicDmpAuthorizationStatus ==
      DmpAuthorizationStatus.Expired
    );
  }

  onSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    this.args.context.shouldAuthorizeMedicToAccessPatientDmp =
      this.shouldAuthorizeMedicToAccessPatientDmp;
    await this.args.context.transitionTo();
  };

  <template>
    {{#if this.isAuthorizationExpired}}
      <div class='ui info message' data-test-expiration-message>
        Votre autorisation d'accès au DMP est expirée, vous devez la renouveler.
      </div>
    {{/if}}

    <form class='ui form' {{on 'submit' this.onSubmit}}>
      <p data-test-label='confirmDmpAccessAuthorization'>
        Confirmez-vous que
        {{@context.patient.fullName}}
        (ou son représentant légal) vous autorise à accéder à son DMP ?
      </p>

      <div class='field'>
        <Checkbox
          @labelName='Le patient (ou son représentant légal) m’a autorisé à accéder à son DMP'
          @checked={{this.shouldAuthorizeMedicToAccessPatientDmp}}
          @onChange={{fn (mut this.shouldAuthorizeMedicToAccessPatientDmp)}}
          @dataTestInput='shouldAuthorizeMedicToAccessPatientDmp'
        />
      </div>

      <div class='form-buttons'>
        <Button
          type='button'
          class='ui fluid form-button'
          {{on 'click' @onDismiss}}
        >
          Annuler
        </Button>
        <Button
          data-test-button='submit-dmp-access-form'
          type='submit'
          class='ui fluid primary form-button
            {{unless this.shouldAuthorizeMedicToAccessPatientDmp "disabled"}}'
        >
          Continuer
        </Button>
      </div>
    </form>
  </template>
}
